<template>
  <el-dialog title="闯关模式" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="1000px">
    <div class="input-box">
      <el-input v-model="input" placeholder="搜索闯关名称" prefix-icon="el-icon-search"></el-input>
      <el-button type="primary" size="small" @click="searchCourses">搜索</el-button>
    </div>
    <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
      <div class="list-box">
        <div class="list" v-for="(item,index) in courseOptions" :key="index">
          <div class="circle-box">
            <el-progress type="circle" :percentage="item.completeRate" width="50" stroke-width="4"></el-progress>
            <div class="txt">
              <p>{{item.name}}</p>
              <p>{{item.introduce}}</p>
            </div>
          </div>
          <span class="span-txt">{{item.completeRate === 100?'已完成':(!item.completeRate?'未开始':'闯关中')}}</span>
          <el-button type="primary" size="small" class="fr" @click="handleSend(item)">发送</el-button>
        </div>

      </div>
      <el-empty description="暂无数据" v-if="!courseOptions.length"></el-empty>
    </div>
  </el-dialog>
</template>

<script>
import courseSubjectBarrierApi from '@/api/course/courseSubjectBarrier'
function initFormBean() {
  const formBean = {
    id: null,
  }
  return formBean
}
export default {
  props: ['currentUser'],
  data() {
    return {
      formVisible: false,
      courseOptions: [],
      input: ''
    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 200;
  },
  watch: {
    input(newValue) {
      if (newValue.trim() === '') {
        this.getOptions();
      }
    }
  },
  methods: {
    handleClick() {

    },
    getOptions(type) {
      courseSubjectBarrierApi.fetchForList({ isGetCompleteRate: 1, state: 1 ,toUserId: this.currentUser.toUserId}).then((res) => {
        let { list } = res.data;
        this.courseOptions = list;
        if (type) this.formVisible = true
      })
    },
    searchCourses() {
      const searchKeyword = this.input.trim();
      if (searchKeyword === '') {
        // 如果搜索关键字为空，重新获取所有闯关数据
        this.getOptions();
      } else {
        // 使用正则表达式进行模糊搜索
        const regex = new RegExp(searchKeyword, 'i');
        this.courseOptions = this.courseOptions.filter(item => regex.test(item.name));
      }
    },
    handleShow() {
      this.form = initFormBean()
      this.getOptions(1)
    },
    handleSend(item) {
      this.formVisible = false;
      this.$emit('created', item, 8)
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  // padding: 10px 0;
}
.list-box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 10px;
  .list {
    background: #eff8fb;
    width: 40%;
    margin-bottom: 20px;
    border-radius: 10px;
    padding: 16px;
    position: relative;
    .circle-box {
      display: flex;
      align-items: center;
      // justify-content: space-between;
      .txt {
        line-height: 22px;
        padding-left: 15px;
        width: calc(100% - 80px);
        p {
          margin: 0;
          font-size: 14px;
          color: #999;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          &:nth-child(1) {
            font-size: 16px;
            color: #000f29;
          }
        }
      }
    }
    .span-txt {
      position: absolute;
      right: 20px;
      top: 34px;
    }
  }
}
.input-box {
  display: flex;
  align-items: center;
  justify-content: center;
  .el-button {
    margin: 0 10px;
  }
}

.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}
::v-deep .date1 .el-input--prefix .el-input__inner {
  padding-left: 0;
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
</style>    